import Analytics from "analytics/util/Analytics";
import {
	formatQueryParamsForPurchaseCallback,
	PRODUCT_NAME_MAP,
	PRODUCT_FEATURE_MAP,
} from "analytics/payment";
import formattedCameFromParam from "analytics/util/cameFrom";
import sourceFromPathname from "analytics/util/source";
import { getQuery } from "analytics/util/helpers";

const CREDIT_CARD = "CC";

export function selectedPaymentTypeOnCheckoutEvent({
	isDefaultPaymentType,
	isSavedCreditCard,
	rateCardName,
	paymentType,
	productSubtype,
	productType,
	currency,
	unitPrice,
	subscriptionSubPeriod,
	tokensCount,
	subPeriodType,
}) {
	// analytics data from the android client
	// 'promo id', 'nway', 'promo design', 'rate card version'
	const formattedQueryParamData = formatQueryParamsForPurchaseCallback();
	const cameFrom = formattedCameFromParam(PRODUCT_NAME_MAP[productSubtype]);
	Analytics.logUIEvent(
		Analytics.eventNames.selectedPaymentOnCheckout,
		{
			data: {
				"rate card name": rateCardName,
				"default payment type": CREDIT_CARD,
				"is default payment type": isDefaultPaymentType,
				"used saved card": isSavedCreditCard,
				"payment type": paymentType,
				"came from": cameFrom,
				"promo id": cameFrom,
				"unit price": unitPrice,
				currency,
				feature: PRODUCT_FEATURE_MAP[productSubtype],
				"feature type": productType,
				source: sourceFromPathname() || getQuery("source"),
				"braze campaign id": getQuery("brazeid"),
				"duration in months": subscriptionSubPeriod,
				"unit quantity": subscriptionSubPeriod || tokensCount,
				"unit period": subPeriodType,
				...formattedQueryParamData,
			},
		},
	);
}

export function callbackStatusOnPurchaseEvent({
	isDefaultPaymentType,
	isSavedCreditCard,
	status,
	productSubtype,
	productType,
	paymentType,
	statusDescription,
	rateCardName,
	unitQuantity,
	unitPrice,
	totalPrice,
	subPeriodType,
}) {
	// analytics data from the android client
	// 'promo id', 'nway', 'promo design', 'rate card version'
	const formattedQueryParamData = formatQueryParamsForPurchaseCallback();

	Analytics.logUIEvent(
		Analytics.eventNames.callbackStatusOnPurchaseTransaction,
		{
			data: {
				"default payment type": CREDIT_CARD,
				"is default payment type": isDefaultPaymentType,
				"used saved card": isSavedCreditCard,
				status: status ? "success" : "failure",
				source: sourceFromPathname() || getQuery("source"),
				platform: process.env.PLATFORM,
				feature: PRODUCT_FEATURE_MAP[productSubtype],
				"feature type": productType,
				"payment type": paymentType,
				"status description": statusDescription,
				"rate card name": rateCardName,
				"unit quantity": unitQuantity,
				"total monthly price": unitPrice,
				"total token price": totalPrice,
				"duration in months": subPeriodType,
				...formattedQueryParamData,
			},
		},
	);
}



// WEBPACK FOOTER //
// ./src/shared/payment/analytics/index.js